module.exports = __webpack_public_path__ + "img/assimi.4987cc03.jpeg";